module.exports = __webpack_public_path__ + "annualreview2018/static/img/focus-areas.83198f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/focus-areas.png
// module id = O1cT
// module chunks = 10